import { ButtonSelectionType } from '../UIElements/ButtonSelectionType'
import { ISelectionContext } from './ISelectionContext'
export default class LegSelectionContext implements ISelectionContext {
  constructor(
    public legNumber: number,
    public buttonSelectionType: ButtonSelectionType
  ) {}
}
